import {SHOW_CONTACT, ShowContactAction} from "./ContactActionTypes";
import {EnrichedDavContact} from "../services/messages/VCardContactData";

export class ContactActions {
    static showContact(contact: EnrichedDavContact): ShowContactAction {
        return {type: SHOW_CONTACT, contact};
    }
}
